import React from "react";
import { PageHeader } from "@/pages/About";

const LegalBody = ({ children }) => (
  <section className="wechr-section">
    <div className="wechr-container max-w-3xl space-y-5 text-sm leading-relaxed text-navy-800">{children}</div>
  </section>
);

const H = ({ children }) => <h2 className="font-heading text-lg font-semibold text-navy-900">{children}</h2>;

const PrivacyPolicy = () => (
  <div>
    <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="How WECH-RB collects, uses, and protects information submitted through the certification platform." />
    <LegalBody>
      <p>This Privacy Policy explains how WECH-RB (“we”, “us”) processes personal and company information you provide when using the certification platform.</p>
      <H>Information We Collect</H>
      <p>We collect account details (name, email, company), application data (company profile, questionnaire answers), and documents you upload as evidence. We also store AI-generated and reviewer-generated assessment results.</p>
      <H>How We Use Information</H>
      <p>We use your information to operate the certification process, perform AI-assisted and admin document reviews, issue and verify certificates, and communicate with you about your application.</p>
      <H>Document Handling</H>
      <p>Uploaded documents are used solely to assess your application against the WECH-RB Code of Conduct. Extracted text may be processed by our AI review provider for the purpose of generating a preliminary gap analysis.</p>
      <H>Data Retention</H>
      <p>We retain application and certificate records for as long as necessary to operate the certification registry and comply with legal obligations.</p>
      <H>Your Rights</H>
      <p>You may request access to, correction of, or deletion of your personal data, subject to legitimate record-keeping requirements for issued certifications.</p>
      <H>Contact</H>
      <p>For privacy inquiries, contact WECH-RB through the details provided on your certification correspondence.</p>
      <p className="text-[var(--wechr-muted-text)]">This document is provided for platform demonstration purposes and does not constitute legal advice.</p>
    </LegalBody>
  </div>
);

export default PrivacyPolicy;
